export async function copiarTextoSeguro(texto, clipboard = globalThis.navigator?.clipboard) {
  if (!clipboard || typeof clipboard.writeText !== 'function') {
    return { copiado: false, motivo: 'no-disponible' }
  }
  try {
    await clipboard.writeText(texto)
    return { copiado: true }
  } catch {
    return { copiado: false, motivo: 'rechazado' }
  }
}
